import React from 'react';

import FullWrapper from '../../layouts-components__common-cases/full-wrapper';

import './style.sass';

const Result = ({ listResult }) => {
    return (
        <div className="teboil-result">
            <FullWrapper>
                <div className="teboil-resultWrapper">
                    <div className="teboil-resultTitle">Результат</div>
                    <div className="teboil-resultText">
                        <div>
                            За&nbsp;4&nbsp;месяца мы&nbsp;создали сайт интернет-магазина
                            с&nbsp;удобной загрузкой контента, легким управлением
                            и&nbsp;максимальной оптимизацией в&nbsp;плане SEO. Выдержали визуальное
                            единство основного сайта бренда Teboil и&nbsp;интернет-магазина масел.
                            Сайт сдан клиенту в&nbsp;срок, релиз состоялся в&nbsp;конце марта
                            2023&nbsp;года.
                        </div>
                        <div>
                            Сайт стал мощной основой для дальнейшего развития сервисов
                            интернет-магазина.
                        </div>
                    </div>
                    <div className="teboil-resultList">
                        <div className="teboil-resultSubtitle">В планах:</div>
                        {listResult.map((item, index) => (
                            <div className="teboil-resultItem" key={index}>
                                <div className="teboil-resultCircle"></div>
                                <div
                                    className="teboil-resultDescription"
                                    dangerouslySetInnerHTML={{ __html: item.description }}
                                />
                            </div>
                        ))}
                    </div>
                </div>
            </FullWrapper>
        </div>
    );
};

export default Result;
